import { useEffect } from 'react';
import { AccountManager, Util, AppInsights } from '@bluedolphin/util-module-mf';
import { useAzureMsal } from '../../../providers/azure';
import { TrackingKeys } from '../../../util/tracking-keys';

/**
 * IdleHandler uses page visibility API with the goal of validating the
 * user session when the browser wakes up from inactivity.
 *
 * https://developer.mozilla.org/en-US/docs/Web/API/Page_Visibility_API
 *
 * Event: visibilitychange
 * Properties: hidden and visibilityState
 *
 */
export default function IdleHandler() {
    const { sessionExpiredHandler } = useAzureMsal();

    useEffect(() => {
        addEventListeners();
        return () => removeEventListeners();
    }, []);

    /**
     * handle visibility change
     */
    function onVisibilitychange() {
        if (!window.document.hidden) {
            const { token } = AccountManager.getTenant();
            if (token && Util.JWT.isExpired(token)) {
                AppInsights.trackEvent(TrackingKeys.AuthIdleHandlerTrigger, {});
                sessionExpiredHandler();
            }
        }
    }

    /**
     * set up event listeners
     */
    function addEventListeners() {
        window.document.addEventListener(
            'visibilitychange',
            onVisibilitychange
        );
    }

    /**
     * remove event listeners
     */
    function removeEventListeners() {
        window.document.removeEventListener(
            'visibilitychange',
            onVisibilitychange
        );
    }

    return null;
}
